export default [
  {
    path: '/',
    name: 'TA-Home',
    component: () => import('@/views/ta/Home.vue'),
    meta: {
      resource: 'TAR0',
      action: 'read',
      pageTitle: 'Startseite',
      breadcrumb: [
        {
          text: 'Startseite',
          active: true,
        },
      ],
    },
  },
  {
    path: '/buchen',
    name: 'TA-Voucher',
    component: () => import('@/views/ta/Voucher.vue'),
    meta: {
      resource: 'TAR0',
      action: 'read',

    },
  },
  {
    path: '/preisabfrage',
    name: 'TA-PriceQuery',
    component: () => import('@/views/PriceQuery.vue'),
    meta: {
      resource: 'TAR0',
      action: 'read',

    },
  },
]